import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import axiosService from 'utils/axios';
import LoadingSpinner from 'components/Shared/LoadingSpinner/LoadingSpinner';
import SearchBar from 'components/SearchBar/SearchBar';
import CardsView from 'components/Shared/CardsView/CardsView';
import ActionButton from 'components/Shared/Buttons/ActionButton';
import CompanyCard from './CompanyCard';
import { companyCardStyles } from './styles';
import AddOrEditCompany from './AddOrEditCompany';

export default function CompanyList() {
  const [isLoading, setIsLoading] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [addNewCompanyModalOpen, setAddNewCompanyModalOpen] = useState(false);

  const getCompanies = useCallback(() => {
    setIsLoading(true);
    axiosService
      .get(`/entities/company/?search=${searchText}`)
      .then(res => {
        setCompanies(res.data);
      })
      .finally(() => setIsLoading(false));
  }, [searchText]);

  const onNewCompanyModalClose = () => {
    getCompanies();
    setAddNewCompanyModalOpen(false);
  };

  useEffect(() => {
    // Fetch companies on mount
    getCompanies();
  }, [getCompanies]);

  return (
    <>
      <SearchBar label="Search a company..." setQuery={setSearchText} />
      <div style={companyCardStyles.actionsContainer}>
        <ActionButton type="add" onClick={() => setAddNewCompanyModalOpen(true)}>
          Company
        </ActionButton>
      </div>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <CardsView
            data={companies}
            emptyMessage="No companies found."
            // @ts-ignore
            CardComponent={CompanyCard}
            onCompanyDelete={getCompanies}
            onCompanyUpdate={getCompanies}
          />
          <AddOrEditCompany
            onSave={onNewCompanyModalClose}
            modalTitle="Add new company"
            isModalOpen={addNewCompanyModalOpen}
            setModalOpen={setAddNewCompanyModalOpen}
          />
        </>
      )}
    </>
  );
}
